import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@siat-fe/env';
import { Observable } from 'rxjs';

/**
 * A raw "lavoro" item as returned by the backend.
 */
export interface LavoroDTO {
  id: number;
  nome: string;
}

@Injectable()
export class ListaLavoriService {
  private readonly endpoint = `${environment.baseUrl}v1/lavoro`;

  private http = inject(HttpClient);

  fetchGetAllLavori(): Observable<LavoroDTO[]> {
    return this.http.get<LavoroDTO[]>(this.endpoint);
  }

  fetchLavoriByModuli(
    moduliIds: (string | number)[]
  ): Observable<LavoroDTO[]> {
    return this.http.post<LavoroDTO[]>(
      `${this.endpoint}/find-by-moduli`,
      moduliIds
    );
  }
}
